export default __webpack_public_path__ + "static/media/PhoneBook.3a4416d4.svg";